import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table, Modal, Button, Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const AdminExamdesk = () => {
  const [gettestEnquiry, setgettestEnquiry] = useState([]);
  const [nochangedata, setnochangedata] = useState([]);
  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
console.log("dfsfds",gettestEnquiry);

  useEffect(() => {
    getalltestEnquiry();
  }, []);

  const getalltestEnquiry = async () => {
    try {
      let res = await axios.get("/api/user/getquebankenquiry");
      if (res.status === 200) {
        setgettestEnquiry(res.data.data.filter(item => item.StudentName)); 
        setnochangedata(res.data.data.filter(item => item.StudentName)); 
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleFilter = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (value !== "") {
      const filteredData = nochangedata.filter((o) =>
        Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(value.toLowerCase())
        )
      );
      setgettestEnquiry(filteredData);
    } else {
      setgettestEnquiry(nochangedata);
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setSelectedId(id);
    setShow(true);
  };

  const Deletetestenquiry = async () => {
    try {
      await axios.delete(`/api/user/deletequebankenquiry/${selectedId}`, {
        headers: { "Content-Type": "application/json" }
      });
      alert("Successfully deleted");
      getalltestEnquiry();
      handleClose();
    } catch (error) {
      console.error("Delete error:", error);
      alert(error.response?.data?.error || "An error occurred");
    }
  };

  return (
    <div className="container mt-5">
      <div className="row mb-3">
        <div className="col-md-4">
          <InputGroup className="mb-3 mt-4">
            <InputGroup.Text><FontAwesomeIcon icon={faMagnifyingGlass} /></InputGroup.Text>
            <Form.Control
              placeholder="Search"
              aria-label="Search"
              value={search}
              onChange={handleFilter}
            />
          </InputGroup>
        </div>
      </div>

      <div className="row">
        <Table striped bordered hover className="text-center">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Student Name</th>
              <th>Class</th>
              <th>Subject</th>
              <th>Chapter</th>
              <th>Board</th>
              <th>WhatsApp No.</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {gettestEnquiry?.map((item, i) => (
              <tr key={item?._id}>
                <td>{i + 1}</td>
                <td>{item?.StudentName}</td>
                <td>{item?.Class}</td>
                <td>{item?.Subject}</td>
                <td>{item?.Chapter}</td>
                <td>{item?.Board}</td>
                <td>{item?.Mobile}</td>
                <td>
                  <FontAwesomeIcon
                    icon={faTrash}
                    style={{ color: "red", cursor: "pointer" }}
                    onClick={() => handleShow(item?._id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3 style={{ color: "#c0392b" }}>Do you really want to delete?</h3>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button variant="danger" onClick={Deletetestenquiry}>Delete</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminExamdesk;
